import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { MuiButton } from "../../../components/mui";
import { MuiCol, MuiRow } from "../../../components/layout";
import { MuiTextArea, MuiTextField } from '../../../components/inputs';


function CmConfigForm({values, onChange, onSave, ...props}) {
	const [name, setName] = useState(values?.name ?? "");
	const [netsuiteInternalId, setNetsuiteInternalId] = useState(values?.netsuiteInternalId ?? "");

	useEffect(()=>{
		setName(values?.name);
		setNetsuiteInternalId(values?.netsuiteInternalId)
	},[values]);

	function onClose(){
		props.onClose();
	}

	function save() {
		onSave({
			cmConfigId:values?.cmConfigId,
			name:name,
			netsuiteInternalId:netsuiteInternalId
		})
	}

  return (
    <>
			<Dialog open={props.isOpen} onClose={onClose} disableEnforceFocus fullWidth>
				<DialogTitle>{t('cm_config.form_title')}</DialogTitle>
					<DialogContent>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextField label={t('cm_config.name')} value={name} onChange={setName}/>
								</MuiCol>
							</MuiRow>
							<br/>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextField label={t('cm_config.netsuite_cm_id')} value={netsuiteInternalId} onChange={setNetsuiteInternalId} />
								</MuiCol>
							</MuiRow>
					</DialogContent>
					<DialogActions>
						<MuiButton color="primary" variant="outlined" onClick={onClose}>{t("cancel")}</MuiButton>
						<MuiButton color="primary" onClick={save}>{t("save")}</MuiButton>
					</DialogActions>
			</Dialog>
    </>
  );
}

CmConfigForm.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(CmConfigForm);